!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.watchlist = e() : t.watchlist = e();
}(window, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var i = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        r.d(n, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 3);
  }([function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = function () {
      function t(t, e, r) {
        this.guid = t, this.name = e, this.uri = r;
      }

      return t.fromProduct = function (e) {
        return new t(e.guid, function t(e) {
          var r = e.name;
          return e.parent ? t(e.parent) + "/" + r : r;
        }(e), e.meta.uri);
      }, t;
    }();

    e.WatchlistItem = n;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(4),
        i = r(0);

    function o(t) {
      var e;

      try {
        e = window[t];
        var r = "__storage_test__";
        return e.setItem(r, r), e.removeItem(r), !0;
      } catch (t) {
        return t instanceof DOMException && (22 === t.code || 1014 === t.code || "QuotaExceededError" === t.name || "NS_ERROR_DOM_QUOTA_REACHED" === t.name) && e && 0 !== e.length;
      }
    }

    var a = "watchlist-item-",
        s = function () {
      function t() {
        o("localStorage") ? this.storage = localStorage : o("sessionStorage") ? this.storage = sessionStorage : (console.error("LocalStorage not available"), this.storage = new n.TransientStorage());
      }

      return t.prototype.has = function (t) {
        return null !== this.storage.getItem(this.buildKey(t));
      }, t.prototype.add = function (t) {
        if (t instanceof i.WatchlistItem) {
          var e = this.buildKey(t);
          this.storage.setItem(e, JSON.stringify(t));
        } else this.add(i.WatchlistItem.fromProduct(t));
      }, t.prototype.remove = function (t) {
        this.storage.removeItem(this.buildKey(t));
      }, t.prototype.get = function (t) {
        var e = this.storage.getItem(a + t);
        if (!e) return null;
        var r = JSON.parse(e);
        return new i.WatchlistItem(r.guid, r.name, r.uri);
      }, t.prototype.getAll = function () {
        for (var t = this.storage, e = [], r = 0; r < t.length; r++) {
          var n = t.key(r);

          if (n && n.substr(0, 15) === a) {
            var i = this.get(n.substr(15));
            i && e.push(i);
          }
        }

        return e;
      }, t.prototype.buildKey = function (t) {
        return a + ("string" == typeof t ? t : t.guid);
      }, t;
    }();

    e.Watchlist = s;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.map = function (t, e) {
      return Array.prototype.map.call(t, e);
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      for (var r in t) {
        e.hasOwnProperty(r) || (e[r] = t[r]);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), n(r(1)), n(r(0)), n(r(5));
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = function () {
      function t() {
        this.map = {};
      }

      return Object.defineProperty(t.prototype, "length", {
        get: function get() {
          return Object.keys(this.map).length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.clear = function () {
        this.map = {};
      }, t.prototype.getItem = function (t) {
        var e = this.map[t];
        return void 0 === e ? null : e;
      }, t.prototype.key = function (t) {
        return this.length >= t ? null : Object.keys(this.map)[t];
      }, t.prototype.removeItem = function (t) {
        delete this.map[t];
      }, t.prototype.setItem = function (t, e) {
        this.map[t] = e;
      }, t;
    }();

    e.TransientStorage = n;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = r(2),
        i = r(1),
        o = r(6),
        a = function a(t, e) {
      var r = e || new i.Watchlist();
      n.map(t.querySelectorAll("[data-pf-watchlist]"), function (e) {
        return new o.WatchlistControl(e, r, t);
      });
    };

    e.WatchlistHelper = a;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var n = r(2),
        i = r(0),
        o = function () {
      function t(t, e, r) {
        this.rootElement = r, this.handleClick = this.handleClick.bind(this), this.element = t, this.watchlist = e, this._guid = this.readGuid(), t.addEventListener("click", this.handleClick), this.watchlist.has(this.guid) ? this.markAsListed() : this.markAsUnlisted();
      }

      return t.prototype.readGuid = function () {
        var t = this.data("guid");
        if (!t) throw new TypeError("Element has no 'data-pf-guid' attribute");
        return t;
      }, Object.defineProperty(t.prototype, "guid", {
        get: function get() {
          var t = this.data("guid");
          if (!t) throw new TypeError("Element has no 'data-pf-guid' attribute");
          return t;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.markAsListed = function () {
        this.markAs("on");
      }, t.prototype.markAsUnlisted = function () {
        this.markAs("");
      }, t.prototype.markAs = function (t) {
        this.element.dataset.pfWatchlist = t, n.map(this.rootElement.querySelectorAll('[data-pf-guid="' + this.guid + '"]'), function (e) {
          return e.dataset.pfWatchlist = t;
        });
      }, t.prototype.handleClick = function (t) {
        t.preventDefault();
        var e = this.watchlist,
            r = this.guid;
        e.has(r) ? (e.remove(r), this.markAsUnlisted()) : (this.addElementToWatchlist(), this.markAsListed());
      }, t.prototype.addElementToWatchlist = function () {
        var t = this.guid,
            e = this.data("name") || t,
            r = this.detectUri();
        this.watchlist.add(new i.WatchlistItem(t, e, r));
      }, t.prototype.data = function (t) {
        var e = this.element;
        return e && e.dataset ? e.dataset["pf" + t.charAt(0).toUpperCase() + t.slice(1)] : void 0;
      }, t.prototype.detectUri = function () {
        var t = this.data("uri");
        if (t) return t;
        var e = this.element;
        return e && e.href && "#" !== e.href ? e.href : window.location.href;
      }, t;
    }();

    e.WatchlistControl = o;
  }]);
});